import { useAuth } from '../../../hooks/useAuth';
import ArtistProfile from './ArtistProfile';
import LinkedArtistSettings from './LinkedArtistSettings';

/**
 * Wrapper component that renders the appropriate profile/settings based on context:
 *
 * CASE 1: Merchant in switched context viewing a linked artist
 *   - Shows: LinkedArtistSettings (can edit artist info, NOT subscription)
 *
 * CASE 2: Linked artist logged in directly
 *   - Shows: LinkedArtistSettings (can edit artist info, NOT subscription)
 *
 * CASE 3: Independent artist (no merchant_id)
 *   - Shows: ArtistProfile (full settings access)
 */
const ArtistProfileWrapper = () => {
  const auth = useAuth();

  if (!auth.isAuthenticated) {
    return null;
  }

  // CASE 1: Merchant in switched context viewing a linked artist
  if (auth.user?.account_type === 'merchant' && auth.isSwitchedContext) {
    // Merchant is viewing a linked artist's settings
    // Show LinkedArtistSettings to allow editing artist info (not subscription)
    return <LinkedArtistSettings />;
  }

  // CASE 2 & 3: Actual artist users
  if (auth.user?.account_type === 'artist') {
    // CASE 2: Linked artist (has merchant_id)
    // merchant_id is at the root level of user object (from UserOut schema)
    const isLinkedArtist = !!auth.user?.merchant_id;

    // CASE 3: Independent artist (no merchant_id)
    return isLinkedArtist ? <LinkedArtistSettings /> : <ArtistProfile />;
  }

  // Fallback for other account types
  return null;
};

export default ArtistProfileWrapper;
